export class ApiError {
    constructor(msg: string, error: boolean)
    {  
      this.msg = msg;
      this.error = error;
    }
    msg: string;
    error: boolean;
}